const ufeApi = require('services/api/ufeApi');
// &env=ufe-dev

function getContent({ path, language, country }) {
    const url = `/api/content${path}?ch=web&loc=${language}-${country}`;

    return ufeApi
        .makeRequest(url, {
            method: 'GET',
            headers: { 'x-requested-source': 'rwd' }
        })
        .then(data => data);
}

module.exports = { getContent };
